const ValidationFunnelValidationRules = () => {
  return (
    <div className="validation-funnel-validation-rules py-4">
      <div className="text-h12 font-semibold text-primaryGray-7">
        Validation Rules content
      </div>
      <p className="text-small text-primaryGray-6">
        Configure validation rules for the funnel here.
      </p>
    </div>
  );
};

export default ValidationFunnelValidationRules;
